<template>
	<div>
    <loading :active.sync="isLoading" :is-full-page="fullPage" :z-index="zIndex"></loading>
    <b-modal id="modalCurriculum" ref="modalCurriculum" dialog-class="modal-full" title="Curriculum" scrollable>
      <curriculum :curriculum="curriculumItem"></curriculum>
      <template slot="modal-footer">
          <b-button variant="secondary" @click="hideModalCurriculum">Close</b-button>
      </template>
    </b-modal>
    <b-modal id="modalAssessment" ref="modalAssessment" size="lg" dialog-class="modal-lg" title="Assessment" scrollable>
      <view-assessment :id="assessment.id"></view-assessment>
      <template slot="modal-footer">
          <b-button variant="secondary" @click="hideModalAssessment">Close</b-button>
      </template>
    </b-modal>
    <b-modal id="modalAddAssessment" ref="modalAddAssessment" size="lg" title="Add assessment" scrollable>
      <template>
        <div class="row">
          <b-col cols="12" sm="12" md="12" lg="12" xl="12">
            <div class="form-group">
              <label for="position">Description <span class="text-danger">*</span></label>
              <div class="input-group"> 
                <b-form-textarea id="textarea-default" v-model="assessment.description" :state="$v.assessment.description.$dirty ? !$v.assessment.description.$error : null" rows="5"></b-form-textarea>
              </div>
            </div>
          </b-col>
          <b-col cols="12" sm="12" md="6" lg="6" xl="6">
            <div class="form-group">
              <label for="status">Status <span class="text-danger">*</span></label>   
              <div class="input-group"> 
                <b-form-select v-model="assessment.assessmentStatusId" :options="assessmentStatusList" :state="$v.assessment.assessmentStatusId.$dirty ? !$v.assessment.assessmentStatusId.$error : null" value-field="id" text-field="description"></b-form-select>
              </div>
            </div>
          </b-col>
          <b-col cols="12" sm="12" md="12" lg="12" xl="12">
            <div class="form-group">
              <label for="status">Confidential (HR personnel from other AFPs can view this assessment). </label>   
              <div class="input-group"> 
                <b-form-checkbox v-model="assessment.confidential" switch size="lg" :value="true"></b-form-checkbox>
              </div>
            </div>
          </b-col>
        </div>
      </template>
      <template slot="modal-footer">
        <b-button variant="primary" @click="createNewAssessment">Next</b-button>
        <b-button variant="secondary" @click="hideModalAddAssessment">Close</b-button>
      </template>
    </b-modal>
    <b-modal id="modalEditAssessment" ref="modalEditAssessment" size="lg" dialog-class="modal-lg" title="Edit Assessment" scrollable>
      <b-tabs card justified>
        <b-tab title="Assessment" active>
          <div class="row">
            <b-col cols="12" sm="12" md="12" lg="12" xl="12">
              <div class="form-group">
                <label for="position">Description <span class="text-danger">*</span></label>
                <div class="input-group"> 
                  <b-form-textarea id="textarea-default" v-model="assessment.description" :state="$v.assessment.description.$dirty ? !$v.assessment.description.$error : null" rows="5"></b-form-textarea>
                </div>
              </div>
            </b-col>
            <b-col cols="12" sm="12" md="6" lg="6" xl="6">
              <div class="form-group">
                <label for="status">Status <span class="text-danger">*</span></label>   
                <div class="input-group"> 
                  <b-form-select v-model="assessment.assessmentStatusId" :options="assessmentStatusList" :state="$v.assessment.assessmentStatusId.$dirty ? !$v.assessment.assessmentStatusId.$error : null" value-field="id" text-field="description"></b-form-select>
                </div>
              </div>
            </b-col>
            <b-col cols="12" sm="12" md="12" lg="12" xl="12">
              <div class="form-group">
                <label for="status">Confidential (HR personnel from other AFPs can view this assessment). </label>   
                <div class="input-group"> 
                  <b-form-checkbox v-model="assessment.confidential" switch size="lg" :value="true"></b-form-checkbox>
                </div>
              </div>
            </b-col>
          </div>
        </b-tab>
        <b-tab title="Files">
          <files :id="assessment.id" />
        </b-tab>
      </b-tabs>
      <div v-if="assessment.updatedBy">
        <div class="col-md-12 mb-2 text-center">
          Modified by <b>{{ assessment.updatedBy.name }} {{ assessment.updatedBy.surname }}</b> at {{ assessment.updatedAt | formatDateTime }}.
        </div>
      </div>
      <template slot="modal-footer">
          <b-button variant="primary" @click="saveEditAssessment">Save</b-button>
        <b-button variant="secondary" @click="hideModalEditAssessment">Close</b-button>
      </template>
    </b-modal>
		<div class="row">
      <div class="col-md-12">
        <b-card>
          <div class="row">
            <b-col xs="12" sm="3" md="3" lg="3" xl="3">
              <div class="form-group">
                <label>Title</label>   
                <div class="input-group"> 
                  <p>{{ selectionProcess.title }}</p>
                </div>
              </div>
            </b-col>
            <b-col xs="12" sm="3" md="3" lg="3" xl="3">
              <div class="form-group">
                <label>Position</label>   
                <div class="input-group"> 
                  <p>{{ selectionProcess.position }}</p>
                </div>
              </div>
            </b-col>
            <b-col xs="12" sm="2" md="2" lg="2" xl="2">
              <div class="form-group">
                <label>AFP</label>   
                <div class="input-group"> 
                  <p v-if="selectionProcess.agency">{{ selectionProcess.agency.name }}</p>
                </div>
              </div>
            </b-col>
            <b-col xs="12" sm="2" md="2" lg="2" xl="2">
              <div class="form-group">
                <label>Status</label>   
                <div class="input-group"> 
                  <p v-if="selectionProcess.selectionProcessStatus">
                    {{ selectionProcess.selectionProcessStatus.description }}<br>
                    <span v-if="selectionProcess.selectionProcessOnGoingStatus"> ({{ selectionProcess.selectionProcessOnGoingStatus.description }})</span>
                  </p>
                </div>
              </div>
            </b-col>
            <b-col xs="12" sm="2" md="2" lg="2" xl="2">
              <div class="form-group">
                <label>Estimated End Date</label>   
                <div class="input-group"> 
                  <p>{{ selectionProcess.endDate | formatDate }}</p>
                </div>
              </div>
            </b-col>
          </div>
          <div class="row">
            <b-col xs="12" sm="12" md="12" lg="12" xl="12" class="mt-1">
              <b-button class="float-right" variant="success" @click="backSelectionProcessList"><i class="fas fa-reply"></i> Back to selection process list</b-button>
            </b-col>
          </div>
        </b-card>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <b-card-title>
            <div class="row">
              <b-col xs="12" sm="6" md="6" lg="6" xl="6">
                Selected CVs
              </b-col>
            </div>
          </b-card-title>
          <div v-if="searchResult.length === 0" class="alert alert-info">No results found for this criteria.</div>
          <div v-else>
            <b-table responsive show-empty hover :items="searchResult" :fields="searchResultFields">
              <template v-slot:cell(edit)="row">
                <b-button v-b-tooltip.hover.left title="View curriculum" variant="info" size="xs" class="ml-1" @click="viewCurriculum(row.item)"><i class="fa fa-search"></i></b-button>
                <b-button v-if="row.item.assessment && (!row.item.assessment.confidential || row.item.agencyId === currentAgency.id)" v-b-tooltip.hover.left title="View Assessment" variant="info" size="xs" class="ml-1" @click="viewAssessment(row.item)"><i class="fas fa-eye"></i></b-button>
                <b-button v-if="row.item.agencyId === currentAgency.id && !row.item.assessment" v-b-tooltip.hover.left title="Add Assessment" variant="primary" size="xs" class="ml-1" @click="addAssessment(row.item)"><i class="fas fa-plus"></i></b-button>
                <b-button v-if="row.item.agencyId === currentAgency.id && row.item.assessment" v-b-tooltip.hover.left title="Edit Assessment" variant="primary" size="xs" class="ml-1" @click="editAssessment(row.item.assessment)"><i class="far fa-edit"></i></b-button>
                <b-button v-if="row.item.agencyId === currentAgency.id && selectionProcess.selectionProcessStatusId === 1" v-b-tooltip.hover.left title="Remove from selection process" variant="danger" size="xs" class="ml-1" @click="removeCurriculum(row.item)"><i class="fas fa-minus-circle"></i></b-button>
                <i v-if="selectionProcess.selectionProcessStatusId !== 1" v-b-tooltip.hover.left class="fas fa-info-circle ml-1" title="Not allowed to remove CV due to status."></i>
              </template>
              <template v-slot:cell(name)="row">
                {{ row.item.candidate.name }} {{ row.item.candidate.surname }}
              </template>
              <template v-slot:cell(createdby)="row">
                {{ row.item.createdBy.name }} {{ row.item.createdBy.surname }}<br>
                <b-badge variant="light">{{ row.item.createdAt | formatDateTime }}</b-badge>
              </template>
              <template v-slot:cell(updatedby)="row">
                {{ row.item.updatedBy.name }} {{ row.item.updatedBy.surname }}<br>
                <b-badge variant="light">{{ row.item.updatedAt | formatDateTime }}</b-badge>
              </template>
              <template v-slot:cell(status)="row">
                <span v-if="row.item.assessment">{{ row.item.assessment.assessmentStatus.description }}</span>
                <span v-else>---</span>
              </template>
            </b-table>
            <b-button variant="secondary" class="ml-2" @click="exportExcel"><i class="fas fa-save"></i>
              Export selected CVs</b-button>
          </div>
        </b-card>
      </div>
    </div>
    <div v-if="currentAgency.id === selectionProcess.agencyId" class="row">
      <div class="col-md-12">
        <CurriculumManagerSearch :id="id" :statusid="selectionProcess.selectionProcessStatusId" :search="mostraSearch" @loadTable="loadCurriculum"></CurriculumManagerSearch>
      </div>
    </div>
	</div>
</template>

<script>
import { authComputed } from '@state/helpers'
import appConfig from '@src/app.config'
import axios from 'axios'
import loading from 'vue-loading-overlay'
import curriculum from '../curriculum/curriculum'
import 'vue-loading-overlay/dist/vue-loading.css'
import CurriculumManagerSearch from './CurriculumManagerSearch.vue'
import viewAssessment from '../assessment/view'
import files from '../assessment/files'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
var qs = require('qs')

export default {
  components: { CurriculumManagerSearch, loading, curriculum, viewAssessment, files },
  mixins: [validationMixin],
  props: {
    id: {
      type: String,
      required: true,
      default: '',
    }
  },
  data() {
    return {
      isLoading: false,
      fullPage: false,
      zIndex: 9999,
      curriculumItem: {},
      selectionProcess: {},
      searchResult: [],
      searchResultFields: [
        {
          key: 'sequenceId',
          label: 'ID'
        },
        {
          key: 'name',
          label: 'Name'
        },
        {
          key: 'createdby',
          label: 'Created By'
        },
        {
          key: 'updatedby',
          label: 'Last Updated By'
        },
        {
          key: 'status',
          label: 'Assessment Status'
        },
        {
          key: 'edit',
          label: 'Options',
          thStyle: { 'word-wrap': 'break-word' },
          thClass: 'text-right',
          tdClass: 'text-right'
        }
      ],
      searched: true,
      assessment: {},
      assessmentStatusList: []
    }
  },
  validations: {
    assessment: {
      description: { required },
      assessmentStatusId: { required }
    }
  },
  computed: {
    ...authComputed,
    mostraSearch: function () {
      return this.searched
    }
  },
  created () {
    this.loadSelectionProcess()
    this.loadCurriculum()
    this.statusList()
  },
  methods: {
    statusList () {
      axios.get(`${appConfig.apiUrl}assessment/status`,
        { headers: { 'Authorization': `Bearer ${this.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
      .then((response) => {
        this.assessmentStatusList = response.data
      })
      .catch(error => {
        this.loginCheck(error.response.status)
        this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
      })
    },
    hideModalAddAssessment () {
      this.$refs['modalAddAssessment'].hide()
    },
    addAssessment (item) {
      this.$v.assessment.$reset()
      this.assessment = {}
      this.assessment.curriculumId = item.id
      this.assessment.selectionProcessId = this.id
      this.$refs['modalAddAssessment'].show()
    },
    createNewAssessment () {
      this.$v.assessment.$reset()
      this.$v.assessment.$touch()
      if (this.$v.assessment.$anyError) {
        this.$notify({group: 'alert', type: 'error', title: 'Form Validation', text: 'Please complete all required fields.'})
      } else {
        this.isLoading = true
        axios.post(`${appConfig.apiUrl}assessment/add`, 
          qs.stringify(this.assessment),
          { headers: { 'Authorization': `Bearer ${this.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
        .then((response) => {
          this.loadCurriculum()
          this.editAssessment(response.data)
          this.hideModalAddAssessment()
          this.$notify({group: 'alert', type: 'success', title: 'Success', text: 'Assessment created successfully.'});
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
        })
      }
    },
    editAssessment(item) {
      this.$v.assessment.$reset()
      this.assessment = item
      this.$refs['modalEditAssessment'].show()
    },
    hideModalEditAssessment () {
      this.$refs['modalEditAssessment'].hide()
    },
    saveEditAssessment () {
      this.isLoading = true
      axios.put(`${appConfig.apiUrl}assessment/update`,
        qs.stringify(this.assessment),
        { headers: { 'Authorization': `Bearer ${this.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
        .then(response => {
          this.$notify({group: 'alert', type: 'success', title: 'Success', text: 'Saved successfully'})
          this.loadCurriculum()
        })
        .finally(() => {
          this.isLoading = false
          this.hideModalEditAssessment()
        })
    },
    viewAssessment (item) {
      this.assessment = item.assessment
      this.$refs['modalAssessment'].show()
    },
    hideModalAssessment () {
      this.$refs['modalAssessment'].hide()
    },
    viewCurriculum (item) {
      this.isLoading = true
      axios.get(appConfig.apiUrl + 'curriculum/' + item.id,
        { headers: { 'Authorization': `Bearer ${this.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
        .then((response) => {
          this.curriculumItem = response.data
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
        })
        .finally(() => {
          this.$refs['modalCurriculum'].show()
          this.isLoading = false
        })
    },
    hideModalCurriculum () {
      this.$refs['modalCurriculum'].hide()
    },
    backSelectionProcessList () {
      this.$emit('callback', false)
    },
    loadSelectionProcess () {
      this.isLoading = true
      axios.get(appConfig.apiUrl + `selection-process/${this.id}`,
      { headers: { 'Authorization': `Bearer ${this.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
      .then((response) => {
        this.selectionProcess = response.data
      })
      .catch(error => {
        this.loginCheck(error.response.status)
        this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    loadCurriculum () {
      this.isLoading = true
      axios.get(appConfig.apiUrl + `selection-process/${this.id}/curriculum`,
      { headers: { 'Authorization': `Bearer ${this.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
      .then((response) => {
        this.searchResult = response.data
      })
      .catch(error => {
        this.loginCheck(error.response.status)
        this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    removeCurriculum (item) {
      this.$bvModal.msgBoxConfirm(`Do you really want to remove curriculum the selection process?`, {
        title: 'Please Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'Yes',
        cancelTitle: 'No',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if (value) {
          this.saveRemove(item)
        }
      })
      .catch(err => {
        console.log(err)
      })
    },
    saveRemove (item) {
      this.isLoading = true
      this.searched = false
      axios.get(`${appConfig.apiUrl}selection-process/${this.id}/remove-curriculum/${item.id}`,
        { headers: { 'Authorization': `Bearer ${this.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
      .then((response) => {
        this.searched = true
        this.loadCurriculum()
        this.$notify({group: 'alert', type: 'success', title: 'Success', text: 'Save Successful.'});
        this.isLoading = false
      })
      .catch(error => {
        this.loginCheck(error.response.status)
        this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
      });
    },
    exportExcel (d) {
      this.isLoading = true
      axios.post(`${appConfig.apiUrl}dashboard/curriculum/export`,
        qs.stringify({
          dados: {
            tipo: 1,
            genderId: d.id,
            selectionProcessId: this.selectionProcess.id
          }
        }),
        {
          headers: { Authorization: `Bearer ${this.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' },
          responseType: 'blob'
        })
        .then(response => {
          if (response.data) {
            var blob = new Blob([response.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            })
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'Export.xlsx')
            document.body.appendChild(link)
            link.click()
            link.remove()
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  }
}
</script>